module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0149.jpg?v=e047dfcc";